import React from "react";
import "../../App.css";
import { useTranslation } from "react-i18next";
import "./Resources.css";

function Resources() {
	const { t } = useTranslation();
	return (
		<div className="resources-container">
			<h1 className="resource">{t("Resources-temp-message")}</h1>
		</div>
	);
}
export default Resources;
